export default {"src":"/_next/static/media/active-location.9ecbf8b0.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};